import { useEffect } from 'react'

export const useClickedOutside = (
  state: boolean,
  setState: (value: boolean) => void,
  ref: any,
) => {
  const handleCloseWhenClickedOutside = (event: any) => {
    if (state && ref.current && !ref.current?.contains(event.target)) {
      setState(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleCloseWhenClickedOutside)

    return () => {
      document.removeEventListener('mousedown', handleCloseWhenClickedOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])
}
